export const ANALYTICS_CUSTOMER = "ANALYTICS_CUSTOMER";
export const ANALYTICS_INTENT = "ANALYTICS_INTENT";
export const ANALYTICS_UTTERANCES = "ANALYTICS_UTTERANCES";
export const ANALYTICS_APP_LIST = "ANALYTICS_APP_LIST";
export const ANALYTICS_MESSAGE = "ANALYTICS_MESSAGE";
export const CREATE_API_KEY = "CREATE_API_KEY";
export const HANDLE_LOADING = "HANDLE_LOADING";
export const HANDLE_ERROR = "HANDLE_ERROR";
export const ANALYTICS_SKILL_ACTIVATION = "ANALYTICS_SKILL_ACTIVATION";
export const ANALYTICS_SUMMARY = "ANALYTICS_SUMMARY";
export const ANALYTICS_CONVERSATIONAL_PATH = "ANALYTICS_CONVERSATIONAL_PATH";
export const DELETE_APP = "DELETE_APP";
